module.exports = __webpack_public_path__ + "img/partiallyDone.9e55cfa3.svg";